import { SearchOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import axios from 'axios';
import TcDevider from 'components/UI/Devider/TcDevider';
import TcInput from 'components/UI/form/input/TcInput';
import TcSelect from 'components/UI/form/input/TcSelect';
import TcMapToolIcon from 'components/UI/Map/components/layout/TcMapToolIcon';
import TcModal from 'components/UI/Modal/TcModal';
import endpointUrls from 'global/Constants/endpointUrls';
import { mapIrToken } from 'global/helperFunctions/mapIrFunctions';
import useQuery from 'global/helperFunctions/useQuery';
import { city } from 'global/Models/globalModels';
import { errorResponse } from 'global/utils/ApiService';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { getAllCitiesWithoutSearch } from 'redux/reducer/basicData/allCitiesWithoutSearch';
import { setLoading, setMapSearchResult } from 'redux/reducer/MapReducer/mapReducer';
import { RootState, store } from 'redux/store';
import TcInputCity from './TcInputCity';
import TcMapSearchResultBox from './TcMapSearchResultBox';

const TcSearchMap: FC = () => {
  //states

  const [open, setOpen] = useState<boolean>(false);
  const [city, setCity] = useState<city | undefined>(undefined);
  // const province = useSelector((state: RootState) => state.province.allProvincesWithoutSearch);
  const allCitiesWithoutSearch = useSelector((state: RootState) => state.city.allCitiesWithoutSearch);
  const { searchLoading, map, searchResults, loading } = useSelector((state: RootState) => state.map);

  //hooks
  const { push } = useHistory();
  const { query, search } = useQuery();

  //effect
  useEffect(() => {
    // if (province?.length === 0 || !province) store.dispatch(fetchProvinceData());
    if (!allCitiesWithoutSearch) store.dispatch(getAllCitiesWithoutSearch());
  }, []);

  useEffect(() => {
    const timeOut = setTimeout(() => {
      if (query.searchPhrase) {
        if (!query.searchPhrase || query.searchPhrase.length < 2) {
          store.dispatch(setMapSearchResult([]));
          return;
        }
        getSearchResult(query.searchPhrase);
      } else {
        store.dispatch(setMapSearchResult([]));
      }
    }, 1000);
    return () => clearTimeout(timeOut);
  }, [search]);

  //functions

  const searchPhraseHandler = (e: any) => {
    const phrase = encodeURIComponent(e.target.value);
    push({ search: `?searchPhrase=${phrase}` });
  };

  //getResultsOfSearch
  const getSearchResult = async (searchPhrase: string) => {
    if (!searchPhrase || query.searchPhrase.length < 2) return store.dispatch(setMapSearchResult([]));
    store.dispatch(setLoading(true));
    await axios
      .post(
        endpointUrls.mapSearchGetAll,
        {
          text: searchPhrase,
          location: {
            type: 'Point',
            coordinates: [map?.getCenter().lng, map?.getCenter().lat],
          },
        },
        {
          headers: {
            'x-api-key': mapIrToken() || '',
          },
        }
      )
      .then((res) => {
        if (res.status == 200) store.dispatch(setMapSearchResult(res?.data?.value || []));
      })
      .catch(() => console.log(errorResponse, 'error'));
    store.dispatch(setLoading(false));

    return;
  };

  const toggleOpen = () => setOpen((prevState) => !prevState);

  const handleCitySearch = (cityId: number) => {
    const selectedCity = allCitiesWithoutSearch?.find((item) => item.id === cityId);
    setCity(selectedCity);
    if (selectedCity?.latitude && selectedCity?.longitude) {
      // toggleOpen();
      map?.flyTo([selectedCity.latitude, selectedCity.longitude], 10);
    }
  };

  return (
    <>
      <TcMapToolIcon title='جستجو' icon={<SearchOutlined />} handleClick={toggleOpen} />
      <TcModal centered loading={loading} visible={open} onCancel={toggleOpen} title='جستجو' footer={false}>
        <div className=''>
          <p className='mt-2 mb-1 text-t-secondary-text-color'>جستجو بر اساس شهر :</p>

          <TcSelect
            showSearch
            allowClear
            className='w-full mb-4'
            value={city?.id}
            placeholder='شهر مورد نظر را انتخاب کنید.'
            onChange={handleCitySearch}
            options={allCitiesWithoutSearch
              ?.map((item) => ({ label: item?.provinceTitle ? item.provinceTitle + ' - ' + item.title : item.title, value: item.id }))
              .sort((a, b) => a.label.localeCompare(b.label))}
          />
          <p className='mb-1 text-t-secondary-text-color'>جستجو اماکن :</p>
          <TcInput allowClear value={decodeURIComponent(query?.searchPhrase || '')} placeholder='نام مکان مدنظر را وارد کنید' onChange={searchPhraseHandler} />
          {searchResults?.length ?? 0 > 0 ? (
            <div className='max-h-[360px] overflow-y-auto pl-4'>
              <TcDevider>نتیجه جستجو :</TcDevider>
              {searchResults?.map((item, index) => {
                return <TcMapSearchResultBox key={index} map={map} result={item} toggleOpen={toggleOpen} />;
              })}
            </div>
          ) : (
            <>
              <div className='hidden'>
                <TcInputCity />
              </div>
            </>
          )}
          {searchLoading && (
            <div className='relative flex items-center px-2 py-1 text-xs bg-t-bg-color bottom-4 gap-x-2'>
              <p className='mb-0'>در حال جستجو</p>
              <div className='relative top-1'>
                <Spin size='small' />
              </div>
            </div>
          )}
        </div>
      </TcModal>
    </>
  );
};

export default TcSearchMap;
